export function trackEvent(action, params = {}) {
  if (typeof window.gtag === "function") window.gtag("event", action, params);
}

export async function submitNewsletterEmail(email, source) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch("/api/newsletter", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, source }), signal: controller.signal,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.ok !== true || data.pendingActivation) {
      throw new Error("Signup could not be confirmed. Please try later, or email info@wealthwiseblog.com to join. The toolkit is available without signing up.");
    }
    return data;
  } catch (error) {
    if (error.name === "AbortError" || error instanceof TypeError) throw new Error("We could not reach the signup service. Please try again shortly.");
    throw error;
  } finally { clearTimeout(timer); }
}
